import { baseUrl } from "../../../config.js";
import { EventBus } from "../../../eventbus";
import { setDocTitle } from "../../../functions/HelperFuncs.js";
import i18n from "../../../functions/i18next.js";

export default {
  data() {
    return {
      sidebar: JSON.parse(
        localStorage.getItem(this.$store.state.company + "_sidebar")
      ),
      company: this.$store.state.company,
      company_full: this.$store.state.company_full,
      user: this.$store.state.user,
      role: this.$store.state.role,
      allUsers: [],
      filteredUsers: [],
      selectedUser: [],
      roles: [],
      state: "",
      searchUser: "",
      filterTitle: "",
      filterMessage: "",
      alterUserRole: "",
      userAddKey: 0,
      userDeleteKey: 0,
      loading: false,
      openOverview: false,
      filterShow: false,
      nameAsc: true,
      nameActive: false,
      userNameAsc: true,
      userNameActive: false,
      roleAsc: true,
      roleActive: false,
      editUser: true,
      adminAmount: 0,
      currentPage: 0,
      perPage: 8,
      isLoadingUsers: false,
      inviteUsed: false,
    };
  },
  computed: {
    pageCount() {
      return Math.ceil(this.filteredUsers.length / this.perPage);
    },
    paginatedUsers() {
      const start = this.currentPage * this.perPage,
        end = start + this.perPage;

      return this.filteredUsers.slice(start, end);
    },
  },
  created: function () {
    setDocTitle("Users", this);

    this.filterTitle = i18n.tc("common.filter");

    if (this.company_full.isActive == "trial-expired") {
      this.$router.push(`/${this.$store.state.company}/billing`);
    } else {
      this.getAllUsers();
      this.getRoles();

      EventBus.$on("right-sidebar-show", () => {
        this.openOverview = true;
      });

      EventBus.$on("right-sidebar-close", () => {
        this.openOverview = false;
      });

      EventBus.$on(`closeallactions`, () => {
        this.openOverview = false;
      });

      EventBus.$on("get-all-users", () => {
        this.getAllUsers();
      });
      EventBus.$on("get-all-roles", () => {
        this.getRoles();
      });
    }
  },
  methods: {
    openRightSidebar(id, data) {
      EventBus.$emit(`right-sidebar-show`, {
        id: id,
        data: data,
      });
    },
    /**
     * Go this route
     * @param route
     */
    goTo(route) {
      this.$router.push(route);
    },
    /**
     * Show the used percentage
     * @returns {number}
     */
    getUsedPercentage() {
      // convert to MB
      let usedMb = this.company_full.usage * 1048576; // bytes to mb
      let totalMb = this.company_full.plan.size * 1048576; // bytes to mb

      return (usedMb / totalMb) * 100;
    },
    /**
     * Get all the users from the current company
     */
    getAllUsers() {
      this.isLoadingUsers = true;
      this.$axios.get(baseUrl + "/companyusers").then((response) => {
        this.allUsers = response.data;

        this.isLoadingUsers = false;

        for (var i = 0; i < this.allUsers.length; i++) {
          let role = this.allUsers[i].roleName;

          if (role == "Administrator") {
            this.adminAmount++;
          }
          this.allUsers[i].role = role;
          if (this.allUsers[i].accepted === 0) {
            this.allUsers[i].username = "";
          }
        }

        this.filteredUsers = this.allUsers.sort((a, b) => {
          const aName = a.name;
          const bName = b.name;

          if (aName < bName) {
            return -1;
          }
          if (aName > bName) {
            return 1;
          }
          // a must be equal to b
          return 0;
        });

        if (this.$route.query.inviterequested && !this.inviteUsed) {
          this.inviteUsed = true;
          this.userAdd();
        }
      });
    },
    /**
     * Get the roles
     */
    getRoles() {
      this.$axios.get(baseUrl + "/companyroles").then((response) => {
        this.roles = response.data.sort((a, b) => {
          const aName = a.name;
          const bName = b.name;

          if (aName < bName) {
            return -1;
          }
          if (aName > bName) {
            return 1;
          }
          // a must be equal to b
          return 0;
        });

        for (let i = 0; i < this.roles.length; i++) {
          this.$axios
            .get(baseUrl + "/roleusers?id=" + this.roles[i].id)
            .then((response) => {
              if (response.data.length === 0) {
                this.roles[i].delete = true;
              } else {
                this.roles[i].delete = false;
              }
            });
        }
      });
    },
    /**
     * Go to the next page of the users overview
     */
    nextPage() {
      if (this.currentPage != this.pageCount - 1) {
        this.currentPage++;
      }
    },
    /**
     * Go to the previous page of the users overview
     */
    prevPage() {
      if (this.currentPage != 0) {
        this.currentPage--;
      }
    },
    /**
     * Open the manage user actions
     * @param value
     */
    openManageUserActions(value) {
      this.state = value;
      if (!this.openOverview) {
        this.openOverview = true;
      }
    },
    /**
     * Open the add user screen
     */
    userAdd() {
      this.openRightSidebar("userAdd", {});
    },
    /**
     * Open the delete user screen
     *
     * @param user
     */
    userDelete(user) {
      this.openRightSidebar("userDelete", user);
    },
    /**
     * Open the update user screen
     *
     * @param user
     */
    userUpdate(user) {
      this.openRightSidebar("userUpdate", user);
    },
    /**
     * Change the user role of the user
     *
     * @param value
     */
    setAlterUserRole(value) {
      if (value === this.alterUserRole) {
        this.alterUserRole = "none";
      } else {
        this.alterUserRole = value;
      }
    },
    /**
     * Update the user role
     *
     * @param email
     * @param role
     */
    updateUserRole(email, role) {
      let formData = new FormData();

      formData.append("mail", email);
      formData.append("role_id", role);

      this.$axios.post(baseUrl + "/invite", formData).then((response) => {
        this.successend = true;
        this.alterUserRole = "";
        this.getAllUsers();
        this.getRoles();
      });
    },
    /**
     * Open the users by role screen
     * @param id
     */
    usersByRole(id, name) {
      this.openRightSidebar("usersByRole", { id, name });
    },
    /**
     * Open the add role screen
     */
    roleAdd() {
      this.openRightSidebar("roleAdd", {});
    },
    /**
     * Open the edit role screen
     * @param id
     */
    editRole(id) {
      this.openRightSidebar("roleEdit", id);
    },
    /**
     * Delete the user role
     * @param role
     * @param deleteRole
     */
    deleteRole(role) {
      this.openRightSidebar("roleDelete", role);
    },
    /**
     * Search on name and username in usersoverview
     */
    searchUsers() {
      if (this.searchUser == "") {
        this.filteredUsers = this.allUsers;
      } else {
        var results = [];
        for (var i = 0; i < this.allUsers.length; i++) {
          /* Check if the names match */
          if (
            this.allUsers[i].name
              .toLowerCase()
              .includes(this.searchUser.toLowerCase())
          ) {
            results.push(this.allUsers[i]);
          }
          /* Check if the usernames match */
          if (
            this.allUsers[i].username
              .toLowerCase()
              .includes(this.searchUser.toLowerCase())
          ) {
            /* Check if the user is already added to the results */
            if (!results.includes(this.allUsers[i])) {
              results.push(this.allUsers[i]);
            }
          }
          /* Check if the email match */
          if (
            this.allUsers[i].email
              .toLowerCase()
              .includes(this.searchUser.toLowerCase())
          ) {
            /* Check if the user is already added to the results */
            if (!results.includes(this.allUsers[i])) {
              results.push(this.allUsers[i]);
            }
          }
        }

        /* Show the users on the screen */
        this.filteredUsers = results;
        this.currentPage = 0;

        if (this.filteredUsers.length === 0) {
          this.filterMessage = i18n.t("manage_users.filter_message");
        } else {
          this.filterMessage = "";
        }
      }
    },

    /**
     * Clear input field
     */
    handleSearchUserClick() {
      this.searchUser = "";
      this.filteredUsers = this.allUsers;
      this.filterMessage = "";
    },

    /**
     * Order the users by name, username or role
     * @param value
     */
    orderBy(value) {
      switch (value) {
        case "name":
          if (this.nameAsc) {
            this.filteredUsers = _.orderBy(
              this.filteredUsers,
              [(user) => user.name.toLowerCase()],
              ["asc"]
            );
          } else {
            this.filteredUsers = _.orderBy(
              this.filteredUsers,
              [(user) => user.name.toLowerCase()],
              ["desc"]
            );
          }
          this.nameActive = true;
          this.userNameAsc = true;
          this.userNameActive = false;
          this.roleAsc = true;
          this.roleActive = false;
          break;
        case "username":
          if (this.userNameAsc) {
            this.filteredUsers = _.orderBy(
              this.filteredUsers,
              [(user) => user.username.toLowerCase()],
              ["asc"]
            );
          } else {
            this.filteredUsers = _.orderBy(
              this.filteredUsers,
              [(user) => user.username.toLowerCase()],
              ["desc"]
            );
          }
          this.userNameActive = true;
          this.nameAsc = true;
          this.nameActive = false;
          this.roleAsc = true;
          this.roleActive = false;
          break;
        case "role":
          if (this.roleAsc) {
            this.filteredUsers = _.orderBy(
              this.filteredUsers,
              [(user) => user.role.toLowerCase()],
              ["asc"]
            );
          } else {
            this.filteredUsers = _.orderBy(
              this.filteredUsers,
              [(user) => user.role.toLowerCase()],
              ["desc"]
            );
          }
          this.roleActive = true;
          this.nameAsc = true;
          this.nameActive = false;
          this.userNameAsc = true;
          this.userNameActive = false;
          break;
      }
    },
    /**
     * Filter the users by role
     * @param value
     * @param title
     */
    filter(value, title) {
      this.filterTitle = title;

      switch (value) {
        case "all":
          this.filteredUsers = this.allUsers;
          break;
        default:
          this.filteredUsers = this.allUsers.filter(
            (user) => user.role === value
          );
      }

      if (this.filteredUsers.length === 0) {
        this.filterMessage = i18n.t("manage_users.filter_message");
      } else {
        this.filterMessage = "";
      }

      //reset page counter on use
      this.currentPage = 0;

      return this.filterTitle, this.filteredUsers, this.filterMessage;
    },
  },
  mounted() {
    /*let self = this;
    setTimeout(function () {
      self.loading = false;
    }, 1000);*/
  },
  destroyed() {
    window.addEventListener("resize", this.updateSidebar);
  },
  watch: {
    filteredUsers() {},
  },
};
